import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setModalOpen,
    setParseDataOfCsvFile,
    setSelectedCsvItem,
    setSelectedCsvItemIndex,
    setModalType,
    setSelectedCsvFileName,
    setSelectedCsvFile
} from 'store/ResponseTemplate/actions';
import { Button, Typography, Box, Grid, Stack } from '@mui/material';
function CancelImportCSV() {
    const dispatch = useDispatch();
    const { selectedCsvItem, selectedCsvItemIndex, parsedCsvData } = useSelector((params) => params.response);
    const handleClose = () => {
        dispatch({ type: setSelectedCsvItem, selectedCsvItem: null });
        dispatch({ type: setSelectedCsvItemIndex, selectedCsvItemIndex: -1 });
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setModalType, modalType: 'list_csv_data' });
        dispatch({ type: setModalOpen, modalOpen: true });
    };
    const handleCancelImport = () => {
        dispatch({ type: setSelectedCsvFile, selectedCsvFile: null });
        dispatch({ type: setSelectedCsvFileName, selectCsvFileName: '' });
        dispatch({ type: setParseDataOfCsvFile, parsedCsvData: [] });
        dispatch({ type: setModalOpen, modalOpen: false });
        // dispatch({ type: setModalType, modalType: 'import-csv' });
        // dispatch({ type: setModalOpen, modalOpen: true });
    };

    return (
        <Stack gap={4}>
            <Typography variant="h6" component="h2" color="#00214D" fontSize="1.25rem" fontWeight="400" fontFamily="Poppins">
                Cancel importing?
            </Typography>
            <Typography component="p" fontSize="0.875rem" color="#00214D">
                Any changes made when reviewing the imported question will be lost.
            </Typography>

            <Stack direction="row" justifyContent="flex-end" gap="10px">
                <Button variant="outlined" className="alternate-reversed" onClick={handleCancelImport} disableRipple>
                    Cancel import
                </Button>
                <Button className="alternate" onClick={handleClose} disableRipple>
                    Stay and review
                </Button>
            </Stack>
        </Stack>
    );
}

export default CancelImportCSV;
